import { create } from "../../../../../common/utils/zustand_state_manager";


type State = {
  status?: string | null;
  idsCentroCusto?: number[];
  equipamento?: string | null;
  responsavelPeloEquipamento?: string | null;
  dataCalibracaoDe?: Date | null;
  dataCalibracaoAte?: Date | null;

};

type Actions = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;

};


export const useEquipamentoMedicaoFilters = create<State & Actions>((set) => ({
  status: "T",
  idsCentroCusto: undefined,
  equipamento: null,
  responsavelPeloEquipamento: null,
  dataCalibracaoDe: null,
  dataCalibracaoAte: null,
  setFilters: (filters) => set(filters),
  clearFilters: () => set({
    status: "T",
    equipamento: null,
    responsavelPeloEquipamento: null,
    dataCalibracaoDe: null,
    dataCalibracaoAte: null,
    idsCentroCusto: [],
  }),

}));